import { SiTypescript } from 'react-icons/si'

export const TypescriptTech = () => {
    return (
        <div>
        <SiTypescript />
        <h4>Typescript</h4>
        </div>
    )
}